import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DEMO_QUESTION_LIMIT, demoPurchaseUrl } from '../demo.constants';
import { DemoService } from '../demo.service';

@Component({
  selector: 'app-demo-complete',
  templateUrl: './demo-complete.component.html',
  styleUrls: ['./demo-complete.component.scss']
})
export class DemoCompleteComponent implements OnInit {
  correctCount = 0;
  answeredCount = 0;
  total = DEMO_QUESTION_LIMIT;

  constructor(
    private demoService: DemoService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  get purchaseUrl(): string {
    return demoPurchaseUrl(localStorage.getItem('language'));
  }

  ngOnInit(): void {
    this.demoService.applyQueryLanguage(
      this.route.snapshot.queryParamMap.get('lang'),
      this.route.snapshot.queryParamMap.get('language')
    );
    if (!this.demoService.hasSession()) {
      this.router.navigate(['/demo']);
      return;
    }
    if (!this.demoService.isCompleted()) {
      this.demoService.markCompleted();
    }
    const score = this.demoService.score();
    this.correctCount = score.correct;
    this.answeredCount = score.answered;
    this.total = score.total;
  }
}
